import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import resourcesToBackend from "i18next-resources-to-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(
    resourcesToBackend(
      (language, namespace) =>
        import(`../public/locales/i18n/${language}/${namespace}.json`),
    ),
  )
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  // passes i18n down to react-i18next
  .init({
    ns: ["locale", "resource"],
    defaultNS: "resource",
    debug: true, // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    fallbackLng: "en", // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    supportedLngs: ["en", "nl"],
    backend: {
      loadPath: "/locales/i18n/{{lng}}/{{ns}}.json",
      // addPath: '/locales/i18n/add/{{lng}}/{{ns}}.json',
    },
    Cache: {
      enabled: false,
      prefix: "translation_",
      expirationTime: Infinity,
      Version: {},
    },
    // saveMissing: true,
    // saveMissingTo: 'all'
  });

export default i18n;
